import { useState, useEffect } from 'react';

export function useSecurityAnalysisModal() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Показываем модальное окно всегда при загрузке страницы
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const closeModal = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    closeModal,
  };
}
